import {useEffect, useRef, useState} from 'react'
import uuid from 'react-uuid'
import {Explorer} from '../../Map/Explorer'
import {Layout} from '../../Map/Layout'
import {useMapaConfig} from '../../../../../../hooks/useMapaConfig'
import {Composicao} from './components/Composicao'
import {BiBuilding, BiBuildingHouse, BiBuildings, BiLayer} from 'react-icons/bi'
import {useExplorerComposicao} from '../../../../../../hooks/useExplorerComposicao'
import {Composicao as ComposicaoClass} from '../../Map/ComponentsControl/ComposicaoControl/composicao'
import {FiltrosImovelLancametoModal} from './components/FiltrosImovelLancametoModal'
import {FiltrosImovelUsadoModal} from './components/FiltrosImovelUsadoModal'
import secureLocalStorage from 'react-secure-storage'
import {Endereco} from '../../Map/ComponentsControl/EnderecoControl/endereco'
import {Button, Modal} from 'react-bootstrap'
import {FiltrosImovelUsadoModalAluguel} from './components/FiltrosImovelUsadoModalAluguel'
import {MutationSetLogAcessoRecurso} from '../../../../../graphql/services/LogAcesso'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useLayout} from '../../../../../../_metronic/layout/core'

export default function FiltroPrincipal() {
  const {FormSetLogAcessoRecurso} = MutationSetLogAcessoRecurso()
  const [show, setShow] = useState(false)
  const [modalShow, setModalShow] = useState(false)
  const [tipoForm, setTipoForm] = useState('')
  const layerActive = useRef(null)
  const {mapaConfig, onMapaConfig} = useMapaConfig()
  const {onUpdateComposicao} = useExplorerComposicao()
  const {config} = useLayout()

  const {aside} = config
  interface Filtro {
    select: {
      type: []
      mercado: []
      bedrooms: []
      parking: []
      finality: []
      bathrooms: []
      stage: []
      developer_name: []
      tipo: []
      quartos: []
      banheiros: []
      vagas: []
      status: []
      finalidade: []
    }
    range: {
      private_area: []
      original_price: []
      area_privativa: []
      preco_m2: []
    }

    nomeCamada: string
    cor: string
  }

  const [filtro, setFiltro] = useState<Filtro>({
    select: {
      type: [],
      mercado: [],
      bedrooms: [],
      parking: [],
      finality: [],
      finalidade: [],
      bathrooms: [],
      stage: [],
      developer_name: [],
      tipo: [],
      quartos: [],
      banheiros: [],
      vagas: [],

      status: [],
    },
    range: {
      private_area: [],
      original_price: [],
      area_privativa: [],
      preco_m2: [],
    },
    nomeCamada: '',
    cor: '',
  })

  function resetFiltro() {
    setFiltro({
      select: {
        type: [],
        mercado: [],
        bedrooms: [],
        parking: [],
        finality: [],
        bathrooms: [],
        stage: [],
        developer_name: [],
        tipo: [],
        quartos: [],
        banheiros: [],
        vagas: [],
        finalidade: [],
        status: [],
      },
      range: {
        private_area: [],
        original_price: [],
        area_privativa: [],
        preco_m2: [],
      },
      nomeCamada: '',
      cor: '',
    })
  }

  function onChangeFiltro(obj: string | number, dados: any, addRemove: string, tipo: string) {
    let filtrotemp = {...filtro}

    if (tipo === 'text') {
      filtrotemp[obj] = dados
    } else if (addRemove === 'add') {
      filtrotemp[tipo][obj].push(dados)
    } else if (addRemove === 'remove') {
      let index = filtrotemp[tipo][obj].indexOf(dados)
      if (index !== -1) {
        delete filtrotemp[tipo][obj][index]
        filtrotemp[tipo][obj].splice(index)
      }
    } else if (addRemove === 'update') {
      filtrotemp[tipo][obj] = dados
    }
    setFiltro(filtrotemp)
  }

  function formatFiltro(filtro) {
    let filtroFinal = {...filtro}
    delete filtroFinal['cor']
    delete filtroFinal['nomeCamada']

    for (var i in filtroFinal['select']) {
      if (filtroFinal['select'][i].length === 0) {
        delete filtroFinal['select'][i]
      }
    }
    for (var j in filtroFinal['range']) {
      if (filtroFinal['range'][j].length === 0) {
        delete filtroFinal['range'][j]
      }
    }

    return filtroFinal
  }

  function onAdicionarCamadaLancamento() {
    FormSetLogAcessoRecurso({
      ferramenta: 'explorer',
      funcionalidade: 'adicionar-lancamentos',
      action: 'click',
      url: `/explorer`,
    })

    let filtroFinal = formatFiltro(filtro)
    let layer = oruloLayer(filtroFinal, filtro.cor)
    let uuid = Explorer.addLayerTile(layer, layer.label)
    secureLocalStorage.setItem('lActive', uuid)
    onMapaConfig({legendaLayerSelected: uuid})
    resetFiltro()
    handleClose()
  }

  function onAdicionarCamadaUsado() {
    FormSetLogAcessoRecurso({
      ferramenta: 'explorer',
      funcionalidade: 'adicionar-usados',
      action: 'click',
      url: `/explorer`,
    })

    let filtroFinal = formatFiltro(filtro)
    let layer = usadoLayer(filtroFinal, filtro.cor)
    Explorer.addLayerTile(layer, layer.label)
    resetFiltro()
  }
  function onAdicionarCamadaUsadoAluguel() {
    FormSetLogAcessoRecurso({
      ferramenta: 'explorer',
      funcionalidade: 'adicionar-aluguel',
      action: 'click',
      url: `/explorer`,
    })

    let filtroFinal = formatFiltro(filtro)
    let layer = usadoLayerAluguel(filtroFinal, filtro.cor)
    Explorer.addLayerTile(layer, layer.label)
    resetFiltro()
  }

  function oruloLayer(filtroFinal, cor = '#ff0000') {
    // const paint = {
    //   'fill-color': cor ? cor : [67, 70, 88],
    //   'circle-radius': 10,
    //   'circle-opacity': 0.9,
    //   'line-width': 5,
    // }

    const paint = {
      'fill-color': [
        'interpolate',
        ['linear'],
        ['to-number', ['get', 'ano_lancamento']],
        2018,
        '#fdae61',
        2019,
        '#f46d43',
        2020,
        '#a6d96a',
        2021,
        '#66bd63',
        2022,
        '#1a9850',
        2023,
        '#2776d7',
        2024,
        '#660068',
        2025,
        '#a50026',
      ],
      'circle-radius': 6,
      'circle-opacity': 0.6,
      positionZ: 20,
    }

    const layerOrulo = {
      descricao: 'Lançamentos',
      zoom_maximo: null,
      url: 'Lançamentos',
      tile: null,
      id: 32,
      layout: '',
      label: 'nome_empreendimento',
      label_info: 'label',
      nacional: 1,
      nome: filtro.nomeCamada !== '' ? filtro.nomeCamada : 'Explorer Mercado Primário',
      nota_tecnica: null,
      paint: {...paint},
      style: {...paint},
      schema_table: 'urbit',
      source_layer: 'view_explorer_launches',
      source: 'view_explorer_launches',
      type: 'MVTLayer',
      composite: 'TextLayer,LayerIcon',
      descricao_completa: '',
      filter: {...filtroFinal},
      icon: 'build',
      link: `/real-estate-launches/[ID]`,
      link_field: 'id_empreendimento',
      explorer_layer_tags: [
        {
          explorer_tags: {
            tag: 'Lançamentos Imobiliários',
            id: 22,
            __typename: 'ExplorerTagsModel',
          },
          __typename: 'ExplorerLayerTagsModel',
        },
      ],
      explorer_tiles: [
        {
          id: 29482,
          id_layer: '32',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'aba781ee-3938-11ee-adfa-2618765f0467',
          type_data: 'range',
          table_name: 'view_explorer_launches',
          select_columns: 'ano_lancamento',
          step: 1,
          table_column: 'ano_lancamento',
          description: 'ano_lancamento',
          data_return:
            '[\r\n    {\r\n        "minimo": "2018",\r\n        "maximo": "2028"\r\n    }\r\n]',
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 29483,
          id_layer: '32',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'aba782d9-3938-11ee-adfa-2618765f0467',
          type_data: 'text',
          table_name: 'view_explorer_launches',
          select_columns: 'nome_empreendimento',
          step: null,
          table_column: 'nome_empreendimento',
          description: 'nome_empreendimento',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 29483,
          id_layer: '32',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'aba782d9-3938-11ee-adfa-2618765f0467',
          type_data: 'select',
          table_name: 'explorer_mercado_primario',
          select_columns: 'incorporador',
          step: null,
          table_column: 'incorporador',
          description: 'incorporador',
          data_return:
            '["3z Realty","3z Realty SP","A88 Empreendimentos","AAM","Abiatar Construtora e Incorporadora","Abud Wagner","ACH Engenharia e Construtora","Adore Incorporações","AgapeeUrb","Agaru","Ager","Agnes Construção","AK Realty","Alfa Realty","Alinc SP","Amici Incorporadora","Ampla Incorporadora","Antuérpia","Apê55","Aporte Empreendimentos","Arbbo","Archtech","Aros Inc","Arquiplan","Articon","ArtLar","ARV Construtora","Atlantis Associados","Aurinova","Avanço Realizações","AW Realty","Azure Incorporadora","Bait Inc","Balassiano","Barbara","Barroco","Belletti Engenharia","Bewiki","Bianchi Realty","Bioma Incorporadora","BKO","Bolsa de Imóveis","BR Corp","Bracco","Bracon","Brasilincorp","Brio Incorporadora","Brio Investimentos","Brix","Bueno Netto","BUILDER","CAC Engenharia","Calçada","Calper","Camargo Corrêa Desenvolvimento Imobiliário","Cambur Construtora","Candemil","Canopus","Canopus RJ","Capital Concreto","Cardim","Carvalho Hosken","Casa Viva","Casa8","Casenge Engenharia","Caucaso","Celta Engenharia","CFL SC","Charles Bigot","CIAPLAN RJ","Conartes","Concal","Concord","Consthruir Engenharia","Constrac","Construtora Você","Contracta","Conx","Conx SP","Cope Engenharia","Coplam","Coral Construtora","Corbetta Construtora","Cordoba Construtora","Costa Hirota","Cota Empreendimentos","CP Construplan","CPD","CSA Empreendimentos","CTV","Cube","Cury","Cury RJ","Cury SP","CWHG","Cyrela","Cyrela RJZ","Cyrela SC","Cyrela SP","D2J","Dama Engenharia","DC4 Empreendimentos","DDK Engenharia","DEM Incorporadora","Diálogo","Dimas Construções","Direcional","Direcional RJ","Direcional SP","Disa Catisa","Dissei Engenharia","Ditolvo","Dois Continentes","Dome","Domma Incorporações","Domum Construções","DW Incorp","EAS Desenvolvimento Imobiliário","EBM SP","Eccoviver","ECM5","Econ Construtora","EDGE","Eduana","Ekko","Emccamp","Emccamp RJ","Emccamp SP","Engefex","Engelux","Enseg","EPH","Epson Engenharia","Épura","Esser","Etaplan","Even","Even RJ","Exemplar Construções","Exemplar Construções ","Exto","EZTEC","Fernandes Araujo","Fibra Experts","FMAC","Focal Inc","Fontana","ForCasa","Fraiha","Fratta Construtora e Incorporadora","Gabbai","Gafisa","Gafisa RJ","Gafisa SP","Gamapro","Gamaro","Gattaz Engenharia","GIP Invest","Global Realty Brasil","Globo Construtora","GN Empreendimentos","GND SC","GPinheiro SC","GR Properties SP","Graal","Grupo Lar","Grupo Lar SP","Grupo OAD","Grupo RG","GTB Empreendimentos","Habitat Arquitetura","Habitram","Hadid Incorporações","Hantei Engenharia","Hausbau","Hausbau SP","Helbor RJ","Helbor SP","Herc Construtora","HM Engenharia","HM Engenharia SP","HM Engenharia SP Interior","Hoepcke","Hogar","Holos Incorporadora","Horto Empreendimentos","Huma","i9 Empreendimentos","i9 Realty","Idea Zarvos","Idea! Zarvos","Ideale","ihouseDi","Imangai","Imobel","Incorpotec","Inkoa","Inner Investimentos","Inovcorp","INTI","Ipap","Itten","ix Incorporadora","J. Gaidzinski","J4S Empreendimentos","JÁ Império Empreendimentos","Jacutinga","Jafet Inc.","Jal","Jalico","JDG Construtora","JF Construtora e Incorporadora","Jive","JLJ","João Fortes","JRG Incorporadora","JSG Construtora","Júlio De David","Kallas","Kaslik","Kauffmann","KDS Engenharia","Kopstein e Liv","Lavvi","LCM Participações","Legítima Incorporadora","Libcorp","Liga Empreendimentos","Lindenberg","Lindenberg SP","Living","Living RJ","Living SP","Livus Inc SP","Locus Inc","Lógica Engenharia","Lopez Marinho","Lorenzini","Lote 5 SP","Luciano Wertheim","Lucio Engenharia","Lumis Construtora","Lumma Construtora","Lumy","M2 Empreendimentos","MAC","Maestra","Mágica Construtora","Magik JC","Maker Incorporadora","Making Engenharia","Mamute Incorporadora","Marka Prime","Marques","Marquise Incorporações","Martinelli Construtora","Maskan","Matos Guimarães","Matushita Engenharia","Max Incorporadora","MB Construtora","Mbigucci","MC3 Engenharia SP","MCP Realty","MDL","MDL RJ","Meta","Metaforma Inc","Metrocasa","MF7","MGTEC Construtora","Migras","Migras ","Milan Reis Realty","Minerva","Mitre Realty","Moby","Modulare Construtora","Montrecon","MOS","Mozak","MPD","MPD SP","MR2 Construtora","MRV RJ","MRV SP","MS Arandu","MSB Sanchez","Mundo Apto","Munir Abbud SP","Munte","My Inc","MZM","Nacional Global","Netcorp Realize","New Properties","Next Realty","Niss","Norbex","Nortis","Novação","Novação Engenharia","Novolar","One","Opportunity","OR","OR RJ","OUZ Group","Paes & Gregori","Paes & Gregori SP","Patriani","Patriani SP","Patrimar","Patrimônio Incorporadora","Paulo Mauro","PDG RJ","PDG SP","Pereda Incorp","Performance","Piemonte SC","Piimo","Pilastter","Pires e Silva Construtora e Incorporadora","Pivô","Planik","Plano W Empreendimentos","Plano&Plano","Platô","PlazzaCorp","Pluma Construtora","Porte","Portus","Pratica Construtora","Prima","Priori","Pró Lotes","Prodomo","Projeto9","Queiroz Galvão","Queiroz Galvão RJ","Quéops Construtora","R. Yazbek","R.A.S","R.A.S.","R.Lico","RDO Empreendimentos","RDR Engenharia","Reacty Incorporadora","Reitzfeld","Reitzfeld SP","REM","Result","REV3 Incorporadora","Rezende","RFM Incorporadora","Riformato","Riva","Riva Incorporadora RJ","Riva RJ","Riva SP","Rodrik Construtora e Administradora","Rossi RJ","Rovic","RRG","S.Quatro","SÁ Cavalcante","Sacisa","Santa Isabel","São José","SDAL","Seed","Seisa Mester Empreendimentos Imobiliários","Senpro","Sensia Incorporadora RJ","Senziani Incorporadora","Sepag Construtora","Sequóia","Setin","Setin SP","Shpaisman","SIG","Sinco RJ","Sinco SP","Sindona","SKR","Solidi","Solv","Solv SP","Somattos Engenharia","Spin","Stan","Start Investimentos","Steffens Construtora","Stiefelmann","Stuhlberger","STV Construções","STX","Sugoi","Sugoi SP","Sulplan","Supervisa Construtora","SWA Realty","TAO","Tarjab","Tavitec","TBO Construção e Incorporação","Tech ZN","Tecnisa","Tecnisa SP","Tecno Apê","Tegra","Tegra RJ","Tegra SP","Teixeira Duarte","Telar Desenvolvimento","Tenda RJ","Tenda SP","Tenerife Empreendimentos Imobiliários","Terras e Terras Incorporações","TGB","Thema","Thera Empreendimentos","Think","THREE","Tibério","TiCO","Tishman Speyer","Toca 55","Toledo Ferrari","Torres Barboza","TPA","Tríplice Engenharia","Trisul","Tropical","TS Incorporação e Construção","UMÃ Inc","Unique MCA","Unity Engenharia","Upcon","Urbic","V&P","V1 Empreendimentos","V2 Empreendimentos","Valente","Veiga Junior","Vibe","Vibra","Vic Engenharia","Vic Engenharia RJ","Vic Engenharia SP","VIEWCO","Vila Brasil Engenharia RJ","Vinx","Virtus","Vitacon","Vitale","Vitaurbana","Vitoria Invest","Vitta Residencial SP","Viva 4 Empreendimentos","Vivaz RJ","Vivaz SP","Vivenda Nobre","V-LOFT","VNW","Você Construtora","W3 Engenharia","WDS","WJB Empreendimentos","WTorre","WZarzur","Xavier Engenharia","Yes Empreendimentos","You Inc","You Inc.","Yuny","Zabo","ZKF","Zogbi"]',
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 29484,
          id_layer: '32',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'aba783c4-3938-11ee-adfa-2618765f0467',
          type_data: 'select',
          table_name: 'view_explorer_launches',
          select_columns: 'tipo',
          step: null,
          table_column: 'tipo',
          description: 'tipo',
          data_return: '[\r\n    "Vertical",\r\n    "Horizontal"\r\n]',
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 29485,
          id_layer: '32',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'aba784b3-3938-11ee-adfa-2618765f0467',
          type_data: 'select',
          table_name: 'view_explorer_launches',
          select_columns: 'finalidade',
          step: null,
          table_column: 'finalidade',
          description: 'finalidade',
          data_return: '[\r\n    "Comercial",\r\n    "Residencial"\r\n]',
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 29486,
          id_layer: '32',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'aba78599-3938-11ee-adfa-2618765f0467',
          type_data: 'select',
          table_name: 'view_explorer_launches',
          select_columns: 'estagio',
          step: null,
          table_column: 'estagio',
          description: 'estagio',
          data_return: '[\r\n    "Em construção",\r\n    "Pronto novo"\r\n]',
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 29487,
          id_layer: '32',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'aba7866e-3938-11ee-adfa-2618765f0467',
          type_data: '',
          table_name: 'view_explorer_launches',
          select_columns: 'total_unidades',
          step: null,
          table_column: 'total_unidades',
          description: 'total_unidades',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 29488,
          id_layer: '32',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'aba78752-3938-11ee-adfa-2618765f0467',
          type_data: '',
          table_name: 'view_explorer_launches',
          select_columns: 'andares',
          step: null,
          table_column: 'andares',
          description: 'andares',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 29489,
          id_layer: '32',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'aba7882d-3938-11ee-adfa-2618765f0467',
          type_data: '',
          table_name: 'view_explorer_launches',
          select_columns: 'apartamentos_por_andar',
          step: null,
          table_column: 'apartamentos_por_andar',
          description: 'apartamentos_por_andar',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 29490,
          id_layer: '32',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'aba78b5e-3938-11ee-adfa-2618765f0467',
          type_data: '',
          table_name: 'view_explorer_launches',
          select_columns: 'area_privativa_minima',
          step: null,
          table_column: 'area_privativa_minima',
          description: 'area_privativa_minima',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 29491,
          id_layer: '32',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'aba78c99-3938-11ee-adfa-2618765f0467',
          type_data: '',
          table_name: 'view_explorer_launches',
          select_columns: 'area_privativa_maxima',
          step: null,
          table_column: 'area_privativa_maxima',
          description: 'area_privativa_maxima',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 29492,
          id_layer: '32',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'aba78d8a-3938-11ee-adfa-2618765f0467',
          type_data: 'range',
          table_name: 'view_explorer_launches',
          select_columns: 'preco_m2',
          step: 1000,
          table_column: 'preco_m2',
          description: 'preco_m2',
          data_return:
            '[\r\n    {\r\n        "minimo": "0",\r\n        "maximo": "60000"\r\n    }\r\n]',
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 29493,
          id_layer: '32',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'aba78e73-3938-11ee-adfa-2618765f0467',
          type_data: '',
          table_name: 'view_explorer_launches',
          select_columns: 'endereco',
          step: null,
          table_column: 'endereco',
          description: 'endereco',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 29494,
          id_layer: '32',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'aba78f78-3938-11ee-adfa-2618765f0467',
          type_data: '',
          table_name: 'view_explorer_launches',
          select_columns: 'incorporador',
          step: null,
          table_column: 'incorporador',
          description: 'incorporador',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 29495,
          id_layer: '32',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'aba79051-3938-11ee-adfa-2618765f0467',
          type_data: '',
          table_name: 'view_explorer_launches',
          select_columns: 'vendas',
          step: null,
          table_column: 'vendas',
          description: 'vendas',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 29496,
          id_layer: '32',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'aba79134-3938-11ee-adfa-2618765f0467',
          type_data: '',
          table_name: 'view_explorer_launches',
          select_columns: 'estoque',
          step: null,
          table_column: 'estoque',
          description: 'estoque',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 29497,
          id_layer: '32',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'aba79210-3938-11ee-adfa-2618765f0467',
          type_data: '',
          table_name: 'view_explorer_launches',
          select_columns: 'vendas_perc',
          step: null,
          table_column: 'vendas_perc',
          description: 'vendas_perc',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 29498,
          id_layer: '32',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'aba79339-3938-11ee-adfa-2618765f0467',
          type_data: '',
          table_name: 'view_explorer_launches',
          select_columns: 'webpage',
          step: null,
          table_column: 'webpage',
          description: 'webpage',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 29500,
          id_layer: '32',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'aba797cb-3938-11ee-adfa-2618765f0467',
          type_data: '',
          table_name: 'view_explorer_launches',
          select_columns: 'linkurbit',
          step: null,
          table_column: 'linkurbit',
          description: 'linkurbit',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
      ],
      __typename: 'ExplorerLayerModel',
    }

    let layer = {...layerOrulo}
    layer['uuid'] = uuid()
    layer['visible'] = true
    layer[
      'tile'
    ] = `${process.env.REACT_APP_MAP_VECTORTILE}/tile/${layerOrulo.source}/{z}/{x}/{y}.pbf?s=${layerOrulo.schema_table}`
    layer['paint'] = {...layerOrulo.paint}
    return layer
  }

  function usadoLayer(filtroFinal, cor = '#ff0000') {
    const layerUsado = {
      descricao: 'Imóveis Usados',
      zoom_maximo: null,
      url: 'view_imoveis_usados',
      tile: null,
      id: 1115,
      layout: null,
      nacional: 1,
      label: '',
      nome: 'Imóveis Usados',
      nota_tecnica: null,
      paint: {
        'fill-color': [
          'interpolate',
          ['linear'],
          ['to-number', ['get', 'preco_m2']],
          4000,
          '#FF3333',
          6000,
          '#FF9933',
          8000,
          '#FFFF33',
          10000,
          '#99FF33',
          12000,
          '#33FF33',
          14000,
          '#33FF99',
          16000,
          '#33FFFF',
          18000,
          '#3399FF',
        ],
        'circle-radius': [
          'interpolate',
          ['linear'],
          ['to-number', ['get', 'quartos']],
          2,
          3,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
        ],
        'fill-opacity': 1,
      },
      schema_table: 'nacional',
      source_layer: 'view_imoveis_usados',
      source: 'view_imoveis_usados',
      type: 'MVTLayer',
      composite: '',
      descricao_completa: null,
      filter: filtroFinal,
      explorer_layer_tags: [],
      explorer_tiles: [
        {
          id: 29485,
          id_layer: '32',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'aba784b3-3938-11ee-adfa-2618765f0467',
          type_data: 'select',
          table_name: 'view_explorer_apartamento_venda_',
          select_columns: 'tipo',
          step: null,
          table_column: 'tipo',
          description: 'tipo',
          data_return:
            '[	"apartamento","cobertura","lancamento","casa","casa-condominio","chacara","Loja-comercial","Ponto-comercial","Imovel-comercial","Sala-comercial","edificio-residencial-comercial","flat","terreno","galpao-comercial","fazenda","sitio"]',
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 16039,
          id_layer: '165',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'ab72d204-3938-11ee-adfa-2618765f0467',
          type_data: '',
          table_name: 'view_explorer_apartamento_venda_',
          select_columns: 'data_acess',
          step: null,
          table_column: 'data_acess',
          description: 'data_acess',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 16040,
          id_layer: '165',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'ab72d309-3938-11ee-adfa-2618765f0467',
          type_data: 'range',
          table_name: 'view_explorer_apartamento_venda_',
          select_columns: 'dias_coleta',
          step: '1',
          table_column: 'dias_coleta',
          description: 'dias_coleta',
          data_return:
            '[\r\n    {\r\n        "minimo": "0",\r\n        "maximo": "90"\r\n    }\r\n]',
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 16044,
          id_layer: '165',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'ab72d696-3938-11ee-adfa-2618765f0467',
          type_data: 'select',
          table_name: 'view_explorer_apartamento_venda_',
          select_columns: 'finalidade',
          step: null,
          table_column: 'finalidade',
          description: 'finalidade',
          data_return: '["venda","aluguel"]',
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        // {
        //   "id": 16045,
        //   "id_layer": "165",
        //   "key_column": null,
        //   "label": null,
        //   "id_column": null,
        //   "uuid": "ab72d775-3938-11ee-adfa-2618765f0467",
        //   "type_data": "range",
        //   "table_name": "view_explorer_apartamento_venda_",
        //   "select_columns": "preco",
        //   "step": "100000",
        //   "table_column": "preco",
        //   "description": "preco",
        //   "data_return": "[\r\n    {\r\n        \"minimo\": \"0\",\r\n        \"maximo\": \"20000000\"\r\n    }\r\n]",
        //   "situacao": "1",
        //   "__typename": "ExplorerTilesModel"
        // },
        {
          id: 16046,
          id_layer: '165',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'ab72d85f-3938-11ee-adfa-2618765f0467',
          type_data: 'range',
          table_name: 'view_explorer_apartamento_venda_',
          select_columns: 'preco_m2',
          step: '1000',
          table_column: 'preco_m2',
          description: 'preco_m2',
          data_return:
            '[\r\n    {\r\n        "minimo": "1000",\r\n        "maximo": "60000"\r\n    }\r\n]',
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 16050,
          id_layer: '165',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'ab72dbdd-3938-11ee-adfa-2618765f0467',
          type_data: 'range',
          table_name: 'view_explorer_apartamento_venda_',
          select_columns: 'suites',
          step: '1',
          table_column: 'suites',
          description: 'suites',
          data_return:
            '[\r\n    {\r\n        "minimo": "0",\r\n        "maximo": "6"\r\n    }\r\n]',
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 16051,
          id_layer: '165',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'ab72dcbe-3938-11ee-adfa-2618765f0467',
          type_data: 'range',
          table_name: 'view_explorer_apartamento_venda_',
          select_columns: 'quartos',
          step: '1',
          table_column: 'quartos',
          description: 'quartos',
          data_return:
            '[\r\n    {\r\n        "minimo": "0",\r\n        "maximo": "6"\r\n    }\r\n]',
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 16052,
          id_layer: '165',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'ab72dd9c-3938-11ee-adfa-2618765f0467',
          type_data: 'range',
          table_name: 'view_explorer_apartamento_venda_',
          select_columns: 'vagas',
          step: '1',
          table_column: 'vagas',
          description: 'vagas',
          data_return:
            '[\r\n    {\r\n        "minimo": "0",\r\n        "maximo": "10"\r\n    }\r\n]',
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 16053,
          id_layer: '165',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'ab72de81-3938-11ee-adfa-2618765f0467',
          type_data: 'range',
          table_name: 'view_explorer_apartamento_venda_',
          select_columns: 'area_privativa',
          step: '5',
          table_column: 'area_privativa',
          description: 'area_privativa',
          data_return:
            '[\r\n    {\r\n        "minimo": "0",\r\n        "maximo": "20000"\r\n    }\r\n]',
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 16054,
          id_layer: '165',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'ab72df5b-3938-11ee-adfa-2618765f0467',
          type_data: '',
          table_name: 'view_explorer_apartamento_venda_',
          select_columns: 'endereco',
          step: null,
          table_column: 'endereco',
          description: 'endereco',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 16055,
          id_layer: '165',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'ab72e038-3938-11ee-adfa-2618765f0467',
          type_data: '',
          table_name: 'view_explorer_apartamento_venda_',
          select_columns: 'link_anunc',
          step: null,
          table_column: 'link_anunc',
          description: 'link_anunc',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 16057,
          id_layer: '165',
          key_column: null,
          label: null,
          id_column: null,
          uuid: 'ab72e416-3938-11ee-adfa-2618765f0467',
          type_data: '',
          table_name: 'view_explorer_apartamento_venda_',
          select_columns: 'fonte',
          step: null,
          table_column: 'fonte',
          description: 'fonte',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
      ],
      __typename: 'ExplorerLayerModel',
    }
    let layer = {...layerUsado}
    layer['uuid'] = uuid()
    layer['visible'] = true
    layer[
      'tile'
    ] = `${process.env.REACT_APP_MAP_VECTORTILE}/tile/${layerUsado.source}/{z}/{x}/{y}.pbf?s=${layerUsado.schema_table}`
    layer['paint'] = {...layerUsado.paint}
    return layer
  }

  function usadoLayerAluguel(filtroFinal, cor = '#ff0000') {
    const layerUsado = {
      descricao: 'Imóveis Aluguel',
      zoom_maximo: null,
      url: 'view_imoveis_usados_locacao',
      tile: null,
      id: 1115,
      layout: null,
      nacional: 1,
      label: '',
      nome: 'Imóveis Aluguel',
      nota_tecnica: null,
      paint: {
        'fill-color': [
          'interpolate',
          ['linear'],
          ['to-number', ['get', 'preco_m2']],
          30,
          '#FF3333',
          40,
          '#FF9933',
          50,
          '#FFFF33',
          60,
          '#99FF33',
          70,
          '#33FF33',
          80,
          '#33FF99',
          90,
          '#33FFFF',
          100,
          '#3399FF',
        ],
        'circle-radius': [
          'interpolate',
          ['linear'],
          ['to-number', ['get', 'quartos']],
          4,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
        ],
        'circle-opacity': 0.6,
      },
      schema_table: 'nacional',
      source_layer: 'view_imoveis_usados_locacao',
      source: 'view_imoveis_usados_locacao',
      type: 'MVTLayer',
      composite: '',
      descricao_completa: null,
      filter: filtroFinal,
      explorer_layer_tags: [],
      explorer_tiles: [
        {
          id: 32170,
          id_layer: '1255',
          key_column: null,
          label: null,
          id_column: null,
          uuid: '930bd52f-9f40-11ee-b708-2618765f0467',
          type_data: null,
          table_name: 'view_imoveis_usados_locacao',
          select_columns: 'data_acess',
          step: null,
          table_column: 'data_acess',
          description: 'data_acess',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 32170,
          id_layer: '1255',
          key_column: null,
          label: null,
          id_column: null,
          uuid: '930bd52f-9f40-11ee-b708-2618765f0467',
          type_data: null,
          table_name: 'view_imoveis_usados_locacao',
          select_columns: 'data_atualizacao',
          step: null,
          table_column: 'data_atualizacao',
          description: 'data_atualizacao',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 32172,
          id_layer: '1255',
          key_column: null,
          label: null,
          id_column: null,
          uuid: '93133d9b-9f40-11ee-b708-2618765f0467',
          type_data: null,
          table_name: 'view_imoveis_usados_locacao',
          select_columns: 'data_remoc',
          step: null,
          table_column: 'data_remoc',
          description: 'data_remoc',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 32173,
          id_layer: '1255',
          key_column: null,
          label: null,
          id_column: null,
          uuid: '931974b2-9f40-11ee-b708-2618765f0467',
          type_data: 'range',
          table_name: 'view_imoveis_usados_locacao',
          select_columns: 'vagas',
          step: 1,
          table_column: 'vagas',
          description: 'vagas',
          data_return: '[\n    {\n        "minimo": "0",\n        "maximo": "10"\n    }\n]',
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 32174,
          id_layer: '1255',
          key_column: null,
          label: null,
          id_column: null,
          uuid: '93197908-9f40-11ee-b708-2618765f0467',
          type_data: 'range',
          table_name: 'view_imoveis_usados_locacao',
          select_columns: 'area_privativa',
          step: 100,
          table_column: 'area_privativa',
          description: 'area_privativa',
          data_return: '[\n    {\n        "minimo": "0",\n        "maximo": "10000"\n    }\n]',
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 32175,
          id_layer: '1255',
          key_column: null,
          label: null,
          id_column: null,
          uuid: '93220234-9f40-11ee-b708-2618765f0467',
          type_data: 'range',
          table_name: 'view_imoveis_usados_locacao',
          select_columns: 'suites',
          step: 1,
          table_column: 'suites',
          description: 'suites',
          data_return: '[\n    {\n        "minimo": "0",\n        "maximo": "10"\n    }\n]',
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 32176,
          id_layer: '1255',
          key_column: null,
          label: null,
          id_column: null,
          uuid: '932204e5-9f40-11ee-b708-2618765f0467',
          type_data: 'range',
          table_name: 'view_imoveis_usados_locacao',
          select_columns: 'banheiros',
          step: 1,
          table_column: 'banheiros',
          description: 'banheiros',
          data_return: '[\n    {\n        "minimo": "0",\n        "maximo": "16"\n    }\n]',
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 32177,
          id_layer: '1255',
          key_column: null,
          label: null,
          id_column: null,
          uuid: '93222a7d-9f40-11ee-b708-2618765f0467',
          type_data: 'range',
          table_name: 'view_imoveis_usados_locacao',
          select_columns: 'quartos',
          step: 1,
          table_column: 'quartos',
          description: 'quartos',
          data_return: '[\n    {\n        "minimo": "0",\n        "maximo": "10"\n    }\n]',
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 32178,
          id_layer: '1255',
          key_column: null,
          label: null,
          id_column: null,
          uuid: '932ac7de-9f40-11ee-b708-2618765f0467',
          type_data: 'range',
          table_name: 'view_imoveis_usados_locacao',
          select_columns: 'preco',
          step: 500,
          table_column: 'preco',
          description: 'preco',
          data_return: '[\n    {\n        "minimo": "0",\n        "maximo": "50000"\n    }\n]',
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 32179,
          id_layer: '1255',
          key_column: null,
          label: null,
          id_column: null,
          uuid: '932ad300-9f40-11ee-b708-2618765f0467',
          type_data: null,
          table_name: 'view_imoveis_usados_locacao',
          select_columns: 'iptu',
          step: null,
          table_column: 'iptu',
          description: 'iptu',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 32180,
          id_layer: '1255',
          key_column: null,
          label: null,
          id_column: null,
          uuid: '932adc6a-9f40-11ee-b708-2618765f0467',
          type_data: 'range',
          table_name: 'view_imoveis_usados_locacao',
          select_columns: 'preco_m2',
          step: 100,
          table_column: 'preco_m2',
          description: 'preco_m2',
          data_return: '[\n    {\n        "minimo": "0",\n        "maximo": "10000"\n    }\n]',
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 32181,
          id_layer: '1255',
          key_column: null,
          label: null,
          id_column: null,
          uuid: '932ade59-9f40-11ee-b708-2618765f0467',
          type_data: null,
          table_name: 'view_imoveis_usados_locacao',
          select_columns: 'dias_coleta',
          step: null,
          table_column: 'dias_coleta',
          description: 'dias_coleta',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 32182,
          id_layer: '1255',
          key_column: null,
          label: null,
          id_column: null,
          uuid: '932ba01a-9f40-11ee-b708-2618765f0467',
          type_data: null,
          table_name: 'view_imoveis_usados_locacao',
          select_columns: 'finalidade',
          step: null,
          table_column: 'finalidade',
          description: 'finalidade',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 32183,
          id_layer: '1255',
          key_column: null,
          label: null,
          id_column: null,
          uuid: '933bf8e3-9f40-11ee-b708-2618765f0467',
          type_data: null,
          table_name: 'view_imoveis_usados_locacao',
          select_columns: 'condominio',
          step: null,
          table_column: 'condominio',
          description: 'condominio',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 32184,
          id_layer: '1255',
          key_column: null,
          label: null,
          id_column: null,
          uuid: '933c0437-9f40-11ee-b708-2618765f0467',
          type_data: null,
          table_name: 'view_imoveis_usados_locacao',
          select_columns: 'status',
          step: null,
          table_column: 'status',
          description: 'status',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 32185,
          id_layer: '1255',
          key_column: null,
          label: null,
          id_column: null,
          uuid: '933c0b8a-9f40-11ee-b708-2618765f0467',
          type_data: null,
          table_name: 'view_imoveis_usados_locacao',
          select_columns: 'link_anunc',
          step: null,
          table_column: 'link_anunc',
          description: 'link_anunc',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 32186,
          id_layer: '1255',
          key_column: null,
          label: null,
          id_column: null,
          uuid: '933c1264-9f40-11ee-b708-2618765f0467',
          type_data: 'text',
          table_name: 'view_imoveis_usados_locacao',
          select_columns: 'endereco',
          step: null,
          table_column: 'endereco',
          description: 'endereco',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 32187,
          id_layer: '1255',
          key_column: null,
          label: null,
          id_column: null,
          uuid: '933c2923-9f40-11ee-b708-2618765f0467',
          type_data: 'select',
          table_name: 'view_imoveis_usados_locacao',
          select_columns: 'tipo',
          step: null,
          table_column: 'tipo',
          description: 'tipo',
          data_return:
            '["apartamento",\n"casa",\n"chacara",\n"cobertura",\n"edificio-residencial-comercial",\n"fazenda",\n"flat",\n"galpao-comercial",\n"Imovel-comercial",\n"lancamento",\n"Ponto-comercial",\n"Sala-comercial",\n"sitio",\n"terreno"\n]',
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
        {
          id: 32191,
          id_layer: '1255',
          key_column: null,
          label: null,
          id_column: null,
          uuid: '933ea89a-9f40-11ee-b708-2618765f0467',
          type_data: null,
          table_name: 'view_imoveis_usados_locacao',
          select_columns: 'fonte',
          step: null,
          table_column: 'fonte',
          description: 'fonte',
          data_return: null,
          situacao: '1',
          __typename: 'ExplorerTilesModel',
        },
      ],
      __typename: 'ExplorerLayerModel',
    }
    let layer = {...layerUsado}
    layer['uuid'] = uuid()
    layer['visible'] = true
    layer[
      'tile'
    ] = `${process.env.REACT_APP_MAP_VECTORTILE}/tile/${layerUsado.source}/{z}/{x}/{y}.pbf?s=${layerUsado.schema_table}`
    layer['paint'] = {...layerUsado.paint}
    return layer
  }

  function lotesEmpreendimento() {
    const municipio = Endereco.getMunicipio()
    let municipiourl = municipio.municipio_url.replace(/-/gm, '_')

    if (municipiourl === 'florianopolis') {
      municipiourl = 'sc_florianopolis'
    }

    var loteFiscalConfig = {
      descricao: 'Lotes fiscais do município',
      zoom_maximo: null,
      url: 'lote_fiscal',
      tile: `${process.env.REACT_APP_MAP_VECTORTILE}/tile/lote_fiscal/{z}/{x}/{y}.pbf?s=${municipiourl}`,
      id: 13,
      layout: '',
      label: 'numero',
      nacional: null,
      nome: 'Lotes fiscais',
      nota_tecnica: null,
      paint: {
        'fill-color': '#c0c0c0',
        'fill-opacity': 0.4,
        'line-width': 1,
        'fill-outline-color': '#000000',
        'line-color': [91, 91, 91],
        // 'text-color': '#333',
      },
      schema_table: municipiourl,
      source_layer: 'lote_fiscal',
      source: 'lote_fiscal',
      type: 'MVTLayer',
      descricao_completa: '',
      selectedPolygon: [],
      explorer_layer_tags: [],
      explorer_tiles: [
        {
          __typename: 'ExplorerTilesModel',
          id: 156,
          id_layer: '13',
          key_column: null,
          label: null,
          id_column: null,
          uuid: '7f4d8206-292e-11ed-9c4a-ea033c27ec52',
          type_data: 'text',
          table_name: 'lote_fiscal',
          select_columns: 'logradouro',
          step: null,
          table_column: 'logradouro',
          description: 'Logradouro',
          data_return: null,
          situacao: '1',
        },
        {
          __typename: 'ExplorerTilesModel',
          id: 157,
          id_layer: '13',
          key_column: null,
          label: null,
          id_column: null,
          uuid: '7f4d833a-292e-11ed-9c4a-ea033c27ec52',
          type_data: 'text',
          table_name: 'lote_fiscal',
          select_columns: 'numero',
          step: null,
          table_column: 'numero',
          description: 'Número',
          data_return: null,
          situacao: '1',
        },
        {
          __typename: 'ExplorerTilesModel',
          id: 162,
          id_layer: '13',
          key_column: null,
          label: null,
          id_column: null,
          uuid: '7f4d87fd-292e-11ed-9c4a-ea033c27ec52',
          type_data: 'range',
          table_name: 'lote_fiscal',
          select_columns: 'area_lote',
          step: '50',
          table_column: 'area_lote',
          description: 'Área de terreno',
          data_return:
            '[\r\n    {\r\n        "minimo": "0",\r\n        "maximo": "50000"\r\n    }\r\n]',
          situacao: '1',
        },
        {
          __typename: 'ExplorerTilesModel',
          id: 163,
          id_layer: '13',
          key_column: null,
          label: null,
          id_column: null,
          uuid: '7f4d88f2-292e-11ed-9c4a-ea033c27ec52',
          type_data: 'range',
          table_name: 'lote_fiscal',
          select_columns: 'area_construida',
          step: '1000',
          table_column: 'area_construida',
          description: 'Área construída',
          data_return:
            '[\r\n    {\r\n        "minimo": "0",\r\n        "maximo": "100000"\r\n    }\r\n]',
          situacao: '1',
        },
        {
          __typename: 'ExplorerTilesModel',
          id: 168,
          id_layer: '13',
          key_column: null,
          label: null,
          id_column: null,
          uuid: '7f4d8e11-292e-11ed-9c4a-ea033c27ec52',
          type_data: 'text',
          table_name: 'lote_fiscal',
          select_columns: 'setor_quadra',
          step: null,
          table_column: 'setor_quadra',
          description: 'Setor-Quadra',
          data_return: null,
          situacao: '1',
        },
        {
          __typename: 'ExplorerTilesModel',
          id: 171,
          id_layer: '13',
          key_column: null,
          label: null,
          id_column: null,
          uuid: '7f4d90d7-292e-11ed-9c4a-ea033c27ec52',
          type_data: 'text',
          table_name: 'lote_fiscal',
          select_columns: 'numero_contribuinte',
          step: null,
          table_column: 'numero_contribuinte',
          description: 'Número do Contribuinte',
          data_return: null,
          situacao: '1',
        },
      ],
      visible: true,
      composite: '',
    }

    let layer = {...loteFiscalConfig}
    layer['uuid'] = uuid()
    layer['visible'] = true
    layer[
      'tile'
    ] = `${process.env.REACT_APP_MAP_VECTORTILE}/tile/${loteFiscalConfig.source}/{z}/{x}/{y}.pbf?s=${loteFiscalConfig.schema_table}`
    layer['paint'] = {...loteFiscalConfig.paint}
    return layer
  }

  function handleShow(event) {
    event.stopPropagation()
    limpaSelecao()
    if (event.target.classList.contains('active')) {
      event.target.classList.remove('active')
      setShow(false)
      setTipoForm('')
    } else {
      event.target.classList.add('active')
      setShow(true)
      setTipoForm('lancamento')
    }
  }

  function handleShowUsados(event) {
    limpaSelecao()
    event.stopPropagation()
    if (event.target.classList.contains('active')) {
      event.target.classList.remove('active')
      setShow(false)
      setTipoForm('')
    } else {
      event.target.classList.add('active')
      setShow(true)
      setTipoForm('usado')
    }
  }

  function handleShowUsadosAluguel(event) {
    limpaSelecao()
    event.stopPropagation()
    if (event.target.classList.contains('active')) {
      event.target.classList.remove('active')
      setShow(false)
      setTipoForm('')
    } else {
      event.target.classList.add('active')
      setShow(true)
      setTipoForm('aluguel')
    }
  }

  function handleEmpreendimentos(event) {
    event.stopPropagation()

    FormSetLogAcessoRecurso({
      ferramenta: 'explorer',
      funcionalidade: 'btn-compor-area',
      action: 'click',
      url: `/explorer`,
    })

    if (event.target.classList.contains('active')) {
      event.target.classList.remove('active')
      limpaSelecao()
      Layout.setModoComposicao(false)
      Layout.setMapaConfig(mapaConfig)
      Explorer.removeLayer(layerActive.current)
      secureLocalStorage.setItem('layerComp', null)
      onUpdateComposicao([])
      setTipoForm('')
      setShow(false)
    } else {
      event.target.classList.add('active')
      setShow(true)
      let layer = lotesEmpreendimento()
      const layerId = Explorer.addLayerTile(layer, 'Lotes Empreendimentos')
      layerActive.current = layerId
      secureLocalStorage.setItem('layerComp', layerId)
      Layout.setModoComposicao(true)
      Layout.setMapaConfig(mapaConfig)
      setTipoForm('composicao')
    }
  }

  const handleCloseCoposicao = () => {
    const itensComposicao = ComposicaoClass.getList()
    if (itensComposicao.length > 0) {
      setModalShow(true)
    } else {
      limpaComposicao()
    }
  }

  function limpaComposicao() {
    document.getElementById('btn-compor-area').classList.remove('active')
    Layout.setModoComposicao(false)
    Layout.setMapaConfig(mapaConfig)
    Explorer.removeLayer(layerActive.current)
    ComposicaoClass.clear()
    setModalShow(false)
    setTipoForm('')
    // setShow(false)
  }

  function limpaSelecao() {
    if (document.getElementById('btn-compor-area').classList.contains('active')) {
      handleCloseCoposicao()
    }
    document.querySelectorAll('.menu-map-item').forEach((element) => {
      element.classList.remove('active')
    })
  }

  const handleClose = () => {
    limpaSelecao()
    setShow(false)
  }

  const showMenu = () => {
    if (document.getElementById('kt_aside_nav_tab_explorer').classList.contains('showMenu')) {
      document.getElementById('kt_aside_nav_tab_explorer').style.display = 'none'
      document.getElementById('kt_aside_nav_tab_explorer').classList.remove('showMenu')
    } else {
      document.getElementById('kt_aside_nav_tab_explorer').style.display = 'block'
      document.getElementById('kt_aside_nav_tab_explorer').classList.add('showMenu')
    }
  }

  const onContinue = () => {
    setModalShow(false)
  }
  return (
    <>
      <ul className=' menu menu-column menu-row align-items-stretch ' style={{height: '64px'}}>
        {aside.display && (
          // <div className='d-flex align-items-center d-lg-none ms-n3 me-1' title='Show aside menu'>
          <li className='item-menu' id='botao-atalho'>
            <button
              className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'
              id='kt_aside_mobile_toggle'
            >
              <KTSVG path='/media/icons/duotune/abstract/abs015.svg' className='svg-icon-2x mt-1' />
            </button>
          </li>
        )}
        <li className='item-menu ms-2 pt-1' id='botao-atalho'>
          <button
            className='menu-link px-5 mt-1   btn   btn-color-gray-700 btn btn-active-success border-right rounded-3 menu-map-item'
            // style={{borderRight: '1px dashed #f7f7f7'}}
            onClick={showMenu}
          >
            <BiLayer className='fs-1'></BiLayer>
            Camadas
          </button>
        </li>

        <li className='item-menu ms-2 pt-1'>
          <button
            className='menu-link px-5 mt-1   btn  btn-color-gray-700 btn btn-active-success border-right rounded-3 menu-map-item'
            // style={{borderRight: '1px dashed #f7f7f7'}}
            onClick={handleShow}
          >
            <BiBuilding className='fs-1'></BiBuilding>
            Lançamentos
          </button>
        </li>
        <li className='item-menu  pt-1'>
          <button
            className='menu-link px-5 mt-1  btn   btn-color-gray-700 btn-active-success  border-right rounded-3 menu-map-item'
            // style={{borderRight: '1px dashed #f7f7f7'}}
            onClick={handleShowUsados}
          >
            <BiBuildingHouse className='fs-1'></BiBuildingHouse>
            Imóveis Venda
          </button>
        </li>
        <li className='item-menu  pt-1'>
          <button
            className='menu-link px-5 btn  mt-1   btn-color-gray-700 btn-active-success  border-right rounded-3 menu-map-item'
            // style={{borderRight: '1px dashed #f7f7f7'}}
            onClick={handleShowUsadosAluguel}
          >
            <BiBuildingHouse className='fs-1'></BiBuildingHouse>
            Imóveis Aluguel
          </button>
        </li>
        <li className='item-menu  pt-1'>
          <button
            id='btn-compor-area'
            className='menu-link px-5 mt-1  btn  btn-color-gray-700 btn-active-success rounded-3 menu-map-item'
            // style={{borderRight: '1px dashed #f7f7f7'}}
            onClick={handleEmpreendimentos}
            disabled={show && tipoForm === 'composicao' ? true : false}
          >
            <BiBuildings className='fs-1'></BiBuildings>
            Compor Área
          </button>
        </li>
      </ul>
      <ModalComposicaoConfirmacao
        showModal={modalShow}
        onHandleClose={limpaComposicao}
        onContinue={onContinue}
      ></ModalComposicaoConfirmacao>
      <FiltrosImovelLancametoModal
        show={show && tipoForm === 'lancamento'}
        onChangeFiltro={onChangeFiltro}
        filtro={filtro}
        onAdicionarCamada={onAdicionarCamadaLancamento}
        onHandleClose={handleClose}
      ></FiltrosImovelLancametoModal>
      <FiltrosImovelUsadoModal
        show={show && tipoForm === 'usado'}
        onChangeFiltro={onChangeFiltro}
        onAdicionarCamada={onAdicionarCamadaUsado}
        onHandleClose={handleClose}
      ></FiltrosImovelUsadoModal>
      <FiltrosImovelUsadoModalAluguel
        show={show && tipoForm === 'aluguel'}
        onChangeFiltro={onChangeFiltro}
        onAdicionarCamada={onAdicionarCamadaUsadoAluguel}
        onHandleClose={handleClose}
      ></FiltrosImovelUsadoModalAluguel>
      <Composicao
        show={show && tipoForm === 'composicao'}
        onChangeFiltro={onChangeFiltro}
        onAdicionarCamada={onAdicionarCamadaUsado}
        onHandleClose={handleCloseCoposicao}
        layerCurrrent={layerActive.current}
      ></Composicao>
    </>
  )
}

type PropsModal = {
  showModal: boolean
  onHandleClose: any
  onContinue: any
}

export const ModalComposicaoConfirmacao: React.FC<PropsModal> = ({
  showModal,
  onHandleClose,
  onContinue,
}) => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    setShow(showModal)
  }, [showModal])

  return (
    <>
      <Modal centered animation show={show} onHide={() => onHandleClose()}>
        <Modal.Header closeButton>
          <Modal.Title>Composição</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Existem itens na composição, deseja continuar?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' data-dismiss='modal' onClick={onHandleClose}>
            Cancelar composição
          </Button>

          <Button variant='primary' data-dismiss='modal' onClick={onContinue}>
            Continuar composição
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
